<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/media/pause-square"></md-icon>
		Pause Your Program Temporarily
	</div>

	<div class="dialog-content">
		<div class="left">
			<div>Need a break</div>
			<div>
				You can pause your academic program for up to 30 days if unforeseen events are preventing you from attending lessons. Simply select your start
				and end dates, and lessons will automatically resume after the break ends. If you're ready to resume earlier, you can do so at any time!
			</div>
		</div>

		<div class="right">
			<div>
				<div>Reason</div>
				<div class="form-field">
					<md-drop-down value="one" [options]="reasonOptions"></md-drop-down>
				</div>
			</div>

			<div>
				<div>Please Provide More Details</div>
				<div class="form-field details-textarea">
					<textarea
						md-form-input
						placeholder="e.g. Traveling for personal reasons, including family commitments and relocation. I'll resume lessons promptly upon return."
						rows="5"
					></textarea>
				</div>
			</div>

			<div>
				<div>Period</div>
				<div class="start-end">
					<input type="date" placeholder="YYYY-MM-DD" value="2024-09-27" md-form-input md-date-picker-input />
					<input type="date" placeholder="YYYY-MM-DD" value="2024-09-27" md-form-input md-date-picker-input />
				</div>
			</div>
		</div>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Cancel</button>
		<button md-button-brand>Update</button>
	</div>
</md-dialog>
